const errorCodeToBaseMessage = {
  'driverShifts.notAllowed': 'Driver shifts cost algorithm is not allowed',
  'dailyAllowance.missing': 'Daily allowance is missing',
  'driverConceptType.missing': 'Driver concept type is not defined',
  'driverConceptType.notMatchingCountry':
    'Driver concept type does not match the selected country',
  'numberOfDrivers.missing': 'Number of drivers is missing',
  'driverSalary.missing': 'Driver salary is missing',
  'numberOfCrewMembers.missing':
    'Number of crew members cannot be empty if crew member salary is provided',
  'crewMemberSalary.missing':
    'Crew member salary cannot be empty if number of crew members is provided',
  'totalDriverCostOverwrite.missing': 'Total driver cost overwrite is missing',
  'country.notMatchingCurrency':
    'Selected country has a different currency than the bus partner. Please select a suitable country or check the country currency configuration.',
  'busTypeCost.missing': 'Vehicle type is not selected',
  'busType.missing': 'Vehicle type is not defined',
  'accommodationCostPerNight.missing':
    'Accommodation cost per night is missing',
  'busUtilizationFactor.outOfRange':
    'Vehicle utilization factor must be a number between 0.0 and 1.0',
  'flixStandardCostOverwrite.notApplicable':
    'Flix standard cost overwrite cannot be used if vehicle utilization factor is empty',
  notMatchingBusProvidedValuesIds:
    'Production cost bus provided values input are invalid.',
  'busTypeCost.multipleBusTypeCostsSelected':
    'Both bus partner and country vehicle type costs are selected.',
  noBusPartnerSelected: 'No bus partner selected.'
};

export const getProvidedValueErrorMessage = (
  errorCode: string,
  scheduleName: string,
  vehicleName: string
) => {
  const baseMessage = errorCodeToBaseMessage[errorCode];
  if (!baseMessage) {
    const fallbackMessage = `Unknown error code for the provided values: ${errorCode}`;
    console.error(fallbackMessage);
    return fallbackMessage;
  }
  return `${baseMessage} for schedule: ${scheduleName}, bus: ${vehicleName}`;
};
